import { render, staticRenderFns } from "./Offers.vue?vue&type=template&id=27f8a0d1&scoped=true&"
import script from "./Offers.vue?vue&type=script&lang=js&"
export * from "./Offers.vue?vue&type=script&lang=js&"
import style0 from "./Offers.vue?vue&type=style&index=0&id=27f8a0d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f8a0d1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27f8a0d1')) {
      api.createRecord('27f8a0d1', component.options)
    } else {
      api.reload('27f8a0d1', component.options)
    }
    module.hot.accept("./Offers.vue?vue&type=template&id=27f8a0d1&scoped=true&", function () {
      api.rerender('27f8a0d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Offers.vue"
export default component.exports